import { deepEqual } from 'fast-equals';
import { useEffect, useState } from 'react';

export function useDeepMemo<T>(value: T) {
  const [state, setState] = useState(value);

  // biome-ignore lint/correctness/useExhaustiveDependencies:
  useEffect(() => {
    if (!deepEqual(state, value)) {
      setState(value);
    }
  }, [value]);

  return state;
}
